import { render, staticRenderFns } from "./02.vue?vue&type=template&id=f3affefc&scoped=true"
import script from "./02.vue?vue&type=script&lang=js"
export * from "./02.vue?vue&type=script&lang=js"
import style0 from "./02.vue?vue&type=style&index=0&id=f3affefc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3affefc",
  null
  
)

export default component.exports